import axios from 'axios';
import { API_URL } from '../common/enum'

const URL = API_URL.HOST + '/request';

export const apiRequest = {
    getAllTmp(token: any) {
        return axios.get(`${URL}/tmp`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },
    getAll(token: any) {
        return axios.get(`${URL}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },
    getAllTmpByUserId(userId: any, token: any) {
        return axios.get(`${URL}/tmp/user/${userId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });

    },
    getAllByUserId(userId: any, token: any) {
        return axios.get(`${URL}/user/${userId}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },
    createRequest(expert: any, token: any) {
        return axios.post(`${URL}`, expert,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },
    getRequestById(id: any, token: any) {
        return axios.get(`${URL}/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    updateRequest(expert: any, token: any) {
        const { id, ...payload } = expert;
        return axios.put(`${URL}/${id}`, payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    deleteRequest(id: any, token: any) {
        return axios.delete(`${URL}/${id}`,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    },

    changeStatus(expert: any, token: any) {
        const { id, ...payload } = expert;
        return axios.put(`${URL}/changeStatus/${id}`, payload,
            {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
    }

};
